export const PRODUCT_STATUS = {
  AVAILABLE: 'Available',
  IN_USE: 'In Use',
  UNDER_MAINTENANCE: 'Under Maintenance',
  DISPOSED: 'Disposed'
};

export const DELIVERY_STATUS = {
  PENDING: 'Pending',
  DELIVERED: 'Delivered',
  CANCELLED: 'Cancelled'
};

export const DELIVERY_PRODUCT_TYPE = {
  NON_REFUNDABLE: 'non-refundable',
  REFUNDABLE: 'refundable',
  CANCELLED: 'Cancelled'
};

export const USER_ROLES = {
  ADMIN: 'admin',
  USER: 'user',
  STORE_KEEPER: 'store_keeper'
};

export const STATUS_COLORS = {
  [PRODUCT_STATUS.AVAILABLE]: 'success',
  [PRODUCT_STATUS.IN_USE]: 'warning',
  [PRODUCT_STATUS.UNDER_MAINTENANCE]: 'info',
  [PRODUCT_STATUS.DISPOSED]: 'danger',
  [DELIVERY_STATUS.PENDING]: 'warning',
  [DELIVERY_STATUS.DELIVERED]: 'success',
  [DELIVERY_STATUS.CANCELLED]: 'danger',
  [DELIVERY_PRODUCT_TYPE.NON_REFUNDABLE]: 'warning',
  [DELIVERY_PRODUCT_TYPE.REFUNDABLE]: 'success',
  [DELIVERY_PRODUCT_TYPE.CANCELLED]: 'danger'
};

export const TABLE_PAGE_SIZES = [10, 25, 50, 100];